import { Box } from "@mui/material";
import { ReactNode } from "react";

type PowerPointSlideProps = {
  children: ReactNode;
};
export default function PowerPointSlide({ children }: PowerPointSlideProps) {
  return (
    <Box
      flexDirection={"column"}
      padding={0}
      margin={0}
      sx={{
        overflow: "hidden",
        display: "flex",
        minHeight: "19.05cm",
        maxHeight: "19.05cm",
        minWidth: "33.867cm",
        maxWidth: "33.867cm",
      }}
    >
      {children}
    </Box>
  );
}
